import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";

export const fetchCreateSixModalInformation = createAppAsyncThunk(
  "createSix/fetchCreateSixModalInformation",
  async(_, { extra }) => await extra.createSixService.getCreateSixModalInformation()
);
